import { LoadingContainer } from 'components/loadingContainer'
import { Spinner } from 'components/loadingContainer/LoadingContainer.styled'
import { PlaceholderContainer } from 'components/placeholder'
import { useSelectedEventForScan } from 'context/SelectedEventForScan'
// eslint-disable-next-line no-restricted-imports
import { CheckAuditorium } from 'features/admin/Ticket/ticketScan/checkAuditorium'
// eslint-disable-next-line no-restricted-imports
import { CheckAuditoriumGeneralSelling } from 'features/admin/Ticket/ticketScan/checkAuditoriumGeneralSelling'
import { useEventByIdAdmin } from 'hooks/admin/useEvents/useEventById'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { SeatSellingModes } from 'types/Event'

export const CheckAuditoriumForEventPage = () => {
    const { selectedEventId } = useSelectedEventForScan()
    const navigate = useNavigate()

    const { data, isLoading, error } = useEventByIdAdmin(selectedEventId || '')

    useEffect(() => {
        if (!selectedEventId) {
            navigate('/admin/jegyellenorzes/esemenyvalasztas', { replace: true })
        }
    }, [selectedEventId, navigate])

    if (!selectedEventId || isLoading || !data) return <Spinner />
    if (error)
        return (
            <PlaceholderContainer>
                <p>Jelenleg nincs esemény, amely megfelel a feltételeknek.</p>
            </PlaceholderContainer>
        )

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            <meta name="robots" content="noindex, nofollow" />
            {data.seat_selling_mode === SeatSellingModes.SeatBased && <CheckAuditorium event={data} />}
            {data.seat_selling_mode === SeatSellingModes.General && <CheckAuditoriumGeneralSelling event={data} />}
        </LoadingContainer>
    )
}
